module.exports = __webpack_public_path__ + "img/Perfume.230f5a83.svg";